import { http } from '../../utils/http'

export interface SaveInvitationDto {
    partyEventId: number
    email: string
}

export interface AcceptInvitationDto {
    reference: string
    actualEmail: string
}

export const insertInvitationAsync = async (
    eventUser: SaveInvitationDto,
    token: string
) : Promise<boolean>  => {
    const result = await http<SaveInvitationDto, null>({
        method: 'post',
        path: 'Invitation',
        accessToken: token,
        body: eventUser
    })
    return (result.ok)
}

 export const insertInvitationAcceptanceAsync = async (
     acceptInvitationDto: AcceptInvitationDto,
     token: string
 ) : Promise<Boolean>  => {
    const result = await http<AcceptInvitationDto, null>({
        method: 'post',
        path: 'InvitationAcceptance',
        accessToken: token,
        body: acceptInvitationDto
    })
    return (result.ok)
}